<template>
    <span v-if="group.id === 1" class="badge badge-info mr-sm-2">{{group.title}}</span>
    <span v-else-if="group.id === 2" class="badge badge-danger mr-sm-2">{{group.title}}</span>
    <span v-else class="badge badge-dark mr-sm-2">{{group.title}}</span>
</template>


<script>
  export default {
    name: 'GroupRender',
    props: ['group']
  }
</script>
